import { toast } from "react-toastify";
import { fetcherFull } from "utils/api";

// Renames a theme via PUT /v2/survey/:surveyId/theme/:themeId.
// Returns { ok, response }.
// On failure, toasts an error and returns { ok: false, response: null }.
// Callers handle post-success side effects (cache mutation, dialog close).
export async function updateThemeName({ surveyId, themeId, name }) {
    let response;
    try {
        response = await fetcherFull(
            `/v2/survey/${surveyId}/theme/${themeId}`,
            "PUT",
            { name },
        );
    } catch (err) {
        toast.error(`Error editing Theme, ${err?.message || "Unknown error"}`);
        console.error(err);
        return { ok: false, response: null };
    }

    if (response?.id) {
        return { ok: true, response };
    }

    const serverError = response?.error || "Unknown issue editing Theme.";
    toast.error(`Error editing Theme, ${serverError}`);
    return { ok: false, response };
}
